export default __webpack_public_path__ + "static/media/bm.0d917b90.svg";